<template>
	<v-dialog v-model="dialog" width="750">
		<v-card class="rounded-xl" elevation="15" color="grey lighten-2">
			<v-card-title class="text-h5">
				Activations
				<v-spacer></v-spacer>
				<v-btn text icon @click="close">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>
			<v-container grid-list-lg>
				<v-layout row wrap justify-center>
					<v-flex :shrink="!$vuetify.breakpoint.xsOnly">
						<NewActivation />
					</v-flex>
					<v-flex :shrink="!$vuetify.breakpoint.xsOnly">
						<PortIn />
					</v-flex>
					<v-flex :shrink="!$vuetify.breakpoint.xsOnly">
						<AddLine />
					</v-flex>
					<v-flex :shrink="!$vuetify.breakpoint.xsOnly">
						<FamilyPlan />
					</v-flex>
					<v-flex :shrink="!$vuetify.breakpoint.xsOnly">
						<HotSpot />
					</v-flex>
				</v-layout>

			</v-container>


		</v-card>
	</v-dialog>
</template>
<script>
import { mapActions } from 'vuex';
import NewActivation from "@/modules/Activation/components/NewNumber.vue"
import PortIn from "@/modules/Activation/components/PortIn.vue"
import HotSpot from "@/modules/Activation/components/HotSpot.vue"
import FamilyPlan from "@/modules/Activation/components/FamilyPlan.vue"
import AddLine from "@/modules/Activation/components/AddLine.vue"

export default {
	name: 'History-Selecter-Dialog',
	props: ['modal'],
	data() {
		return {
			dialog: false
		}
	},
	components: {
		PortIn,
		AddLine,
		HotSpot,
		NewActivation,
		FamilyPlan,
	},
	methods: {
		...mapActions('global', ['setRandomNumber']),
		close() {

			this.$emit('close')
		},
		openOrderHistory() {

			this.$router.push({ path: "/History/orders" });
		},
		openSimHistory() {

			this.$router.push({ path: "/History/sims" });
		}
	},
	watch: {
		modal(val) {
			if (val) {
				return this.dialog = true
			}
			return this.dialog = false
		},
		dialog(val) {
			if (!val) {
				this.$emit('close')
			}
		}
	}
}
</script>
<style scoped>
.glassCard {
	/* From https://css.glass */
	background: rgba(225, 190, 231, 0.11) !important;
	border-radius: 16px;
	box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
	backdrop-filter: blur(8.2px);
	-webkit-backdrop-filter: blur(8.2px);
	border: 1px solid rgba(225, 190, 231, 0.68) !important;
}
</style>